module.exports = __webpack_public_path__ + "c0ea664a0bd5ae416fa0d0ed8b7e7984.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/10/North_star_web_news.png
// module id = 234
// module chunks = 0